import { baseFetchToken } from './BaseSaga'
import SupplierActions from '../Redux/SupplierRedux'
import { getToken } from '../Services/GetToken'

export function * getSupplier (api, action) {
  yield baseFetchToken(
    api.getSupplier,
    action.data,
    getToken,
    SupplierActions.getSupplierSuccess,
    SupplierActions.getSupplierFailure
  )
}

export function * createSupplier (api, action) {
  yield baseFetchToken(
    api.createSupplier,
    action.data,
    getToken,
    SupplierActions.createSupplierSuccess,
    SupplierActions.createSupplierFailure
  )
}

export function * updateSupplier (api, action) {
  yield baseFetchToken(
    api.updateSupplier,
    action.data,
    getToken,
    SupplierActions.updateSupplierSuccess,
    SupplierActions.updateSupplierFailure
  )
}

export function * deleteSupplier (api, action) {
  yield baseFetchToken(
    api.deleteSupplier,
    action.data,
    getToken,
    SupplierActions.deleteSupplierSuccess,
    SupplierActions.deleteSupplierFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/SupplierSagas.js